import { createLiveStore, useRpc } from "../lib/live-store";
import type { Category, Subcategory } from "../types/api";

interface CategoriesData {
  categories: Category[];
}

export const useCategoryStore = createLiveStore<CategoriesData>({
  topic: "categories",
  onSnapshot: (data) => ({ categories: data as Category[] }),
  state: () => ({ categories: [] }),
});

interface SubcategoriesData {
  subcategories: Subcategory[];
}

interface SubcategoriesExtra {
  categoryId: number | undefined;
  setCategoryId: (id: number | undefined) => void;
}

export const useSubcategoryStore = createLiveStore<SubcategoriesData, SubcategoriesExtra>({
  topic: (s) =>
    s.categoryId ? `categories.${s.categoryId}.subcategories` : "subcategories",
  onSnapshot: (data) => ({ subcategories: data as Subcategory[] }),
  state: (set) => ({
    subcategories: [],
    categoryId: undefined,
    setCategoryId: (id: number | undefined) => set({ categoryId: id, subcategories: [], _loading: true } as any),
  }),
});

export function useCreateCategory() { return useRpc("category.create"); }
export function useUpdateCategory() { return useRpc("category.update"); }
export function useDeleteCategory() { return useRpc("category.delete"); }
export function useCategoryAffectedAssets() { return useRpc("category.affectedAssets"); }
export function useCreateSubcategory() { return useRpc("subcategory.create"); }
export function useUpdateSubcategory() { return useRpc("subcategory.update"); }
export function useDeleteSubcategory() { return useRpc("subcategory.delete"); }
export function useSubcategoryAffectedAssets() { return useRpc("subcategory.affectedAssets"); }
